import useIsSuperUser from '@/services/hooks/useIsSuperUser'
import { useDemoModeContext } from '@/components/demo-mode-provider/DemoModeProvider'

export default function useIsSuperUserVisible() {
  const isSuperUser = useIsSuperUser()
  const [demoMode] = useDemoModeContext()

  return isSuperUser && !demoMode
}
